export const FILTER_OPTIONS = {
  ALL: {
    label: 'All',
    value: 'all',
    group: 'all',
  },
  ACTIVE: {
    label: 'Active',
    value: 'active',
    group: 'success',
  },
  RECOVERED: {
    label: 'Recovered',
    value: 'recovered',
    group: 'success',
  },
  TRIALING: {
    label: 'Trialing',
    value: 'trialing',
    group: 'success',
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
    group: 'success',
  },
  COMPLETED: {
    label: 'Completed',
    value: 'completed',
    group: 'success',
  },
  PAST_DUE: {
    label: 'Overdue',
    value: 'past_due',
    group: 'pending',
  },
  INCOMPLETE: {
    label: 'Incomplete',
    value: 'incomplete',
    group: 'pending',
  },
  ABANDONED: {
    value: 'abandoned',
    label: 'Abandoned',
    group: 'pending',
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
    group: 'failed',
  },
  FAILED: {
    label: 'Failed',
    value: 'failed',
    group: 'failed',
  },
};

export const COUPON_FILTER_OPTIONS = {
  ALL: {
    label: 'All',
    value: 'all',
  },
  ACTIVE: {
    label: 'Active',
    value: 'active',
  },
  RECOVERED: {
    label: 'Recovered',
    value: 'recovered',
  },
  TRIALING: {
    label: 'Trialing',
    value: 'trialing',
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
  },
  COMPLETED: {
    label: 'Completed',
    value: 'completed',
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
  },
  PAST_DUE: {
    label: 'Overdue',
    value: 'past_due',
  },
};
